import "./index.css";
import React from "react";

export default function ContentBlock({ contentObj, i }) {
  return contentObj ? (
    <div className="content-block">
      <div className="content-block__container">
        <div className="content-block__sub-container">
          <img
            src={contentObj.image.src}
            alt={contentObj.image.alt}
            className="content-block__img"
          />
          <h3 className="content-block__sub-title">{contentObj.title}</h3>
        </div>
        <h4 className="content-block__why">{`Why#${i}?`}</h4>
      </div>
      <p className="content-block__text">{contentObj.paragraph}</p>
    </div>
  ) : null;
}



// WEBPACK FOOTER //
// ./src/screens/AdminRegistration/components/ContentBlock/index.js